export default __webpack_public_path__ + "3c3c9f517e52b71e91f716fc5e79fd8c.png";